import decode from 'jwt-decode';

const LOCAL_STORAGE_TOKEN_KEY = 'id_token';

class AuthService {
  /*
      {
        "data": {
          "firstName": "Q",
          "email": "queendoescode@gmail.com",
          "_id": "6a812e992b33ea297a5feef5"
        },
        "iat": 1786925972,
        "exp": 1789517972
      }
  */
  getProfile() {
    return decode(this.getToken());
  }

  loggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken();
    return token && ! this.isTokenExpired(token);
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token);
      return decoded.exp < Date.now() / 1000;
    }
    catch (err) {
      return true;
    }
  }

  getToken() {
    return localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
  }

  setToken(idToken) {
    localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, idToken);
  }

  // login(idToken) {
  //   this.setToken(idToken);

  //   window.location.assign('/');
  // }

  removeToken() {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
  }

  logout() {
    // Clear user token and profile data from localStorage
    this.removeToken();

    // this will reload the page and reset the state of the application
    window.location.assign('/');
  }
}

const Auth = new AuthService();

export default Auth;
